<template>
  <div id="index">
    <el-container>
      <div :class="isCollapse ? 'menu_hide rightSide ' : 'rightSide '" ref="rightSide">
        <el-main class="index">
          <!-- <div class="bland fl"> 
          <span >Welcome to HELIX</span>
        </div> -->
          <nav-bar></nav-bar>
          <el-row :gutter="24">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" ref="leftCon">
              <el-row :gutter="24">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <div class="homeCon">
                    <div class="mapNum" ref="mapnum" id="mapnum" @click="toInstallKPI()">
                      <el-row :gutter="24">
                        <el-col :xs="12" :sm="12" :md="12" :lg="6">
                          <div
                            style="cursor: pointer"
                          >
                            <img src="~assets/img/icon_Shipped.png" />
                            <div style="display: inline-block">
                              <h4 class="BoxTitle">
                                {{ $t("desc.sendOutNumber") }}
                              </h4>
                              <strong class="BoxNum">
                                {{ deviceStatInfo.sendOutCount }}
                              </strong>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="6">
                          <div style="cursor: pointer" >
                            <img src="~assets/img/icon_Registered.png" />
                            <div style="display: inline-block">
                              <h4 class="BoxTitle">
                                {{ $t("desc.TotalRegistratedNumber") }}
                              </h4>
                              <strong class="BoxNum"
                                >{{ deviceStatInfo.bindCount }}
                              </strong>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="6">
                          <div style="cursor: pointer" >
                            <img src="~assets/img/icon_Connected_Active.png" />
                            <div style="display: inline-block">
                              <h4 class="BoxTitle">
                                {{ $t("desc.OnlineNumber") }}
                              </h4>
                              <strong class="BoxNum">
                                {{ deviceStatInfo.onLineCount }}
                              </strong>
                            </div>
                          </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="6">
                          <div style="cursor: pointer" >
                            <img src="~assets/img/icon_Connected_Offline.png" />
                            <div style="display: inline-block">
                              <h4 class="BoxTitle">
                                {{ $t("desc.DisconnectedNumber") }}
                              </h4>
                              <strong class="BoxNum">
                                {{ deviceStatInfo.unConnectCount }}
                              </strong>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8">
                  <div class="homeCon" style="height: 453px">
                    <h4 class="BoxTitle">
                      {{ $t("desc.healthDegree") }}
                      <strong class="fr" @click="toTripRate()" style="cursor: pointer"
                        >{{ healthStatInfo.healthRate }}%</strong
                      >
                    </h4>
                    <h5 class="subTitle">
                      {{ $t("desc.lastmonth") }}
                      <strong
                        v-bind:class="
                          healthStatInfo.healthRateTB > 0
                            ? 'fr green'
                            : healthStatInfo.healthRateTB < 0
                            ? 'fr red'
                            : 'fr'
                        "
                        >{{ healthStatInfo.healthRateTB }}%
                        <i v-if="healthStatInfo.healthRateTB > 0" class="el-icon-top"></i>
                        <i
                          v-if="healthStatInfo.healthRateTB == 0"
                          class="el-icon-minus"
                        ></i>
                        <i
                          v-if="healthStatInfo.healthRateTB < 0"
                          class="el-icon-bottom"
                        ></i>
                      </strong>
                    </h5>
                    <div
                      class="homeEchart npPointer"
                      id="HealthLine"
                      style="
                        height: 280px;
                        margin-top: 22px;
                        border-radius: 16px;
                        background: #1f222b;
                      "
                    ></div>
                    <!-- <div
                      class="homeEchart"
                      id="HealthBar"
                      style="height: 10px; margin-top: 15px"
                      @click="toTripRate()"
                    ></div> -->
                    <div class="divide"></div>
                    <el-row :gutter="24">
                      <!-- <el-col :xs="12" :sm="12" :md="6" :lg="12">
                        <div class="HealthRateUl" style="border-color: #28739a">
                          <strong
                            class="HealthNum"
                            @click="toMaintain('0')"
                            style="cursor: pointer"
                            >{{ healthStatInfo.waitServiceCount }}
                          </strong>
                          <h4 class="HealthTitle">
                            {{ $t("desc.NumberforService") }}
                          </h4>
                        </div>
                      </el-col>
                      <el-col :xs="12" :sm="12" :md="6" :lg="12">
                        <div class="HealthRateUl" style="border-color: #99a2ac">
                          <strong
                            class="HealthNum"
                            @click="toMaintain('2')"
                            style="cursor: pointer"
                            >{{ healthStatInfo.expireServiceCount }}
                          </strong>
                          <h4 class="HealthTitle">
                            {{ $t("desc.NumberofServiceOverdue") }}
                          </h4>
                        </div>
                      </el-col> -->
                      <el-col :xs="12" :sm="12" :md="6" :lg="12">
                        <div class="HealthRateUl" style="border-color: #fcbc5d">
                          <strong
                            class="HealthNum"
                            @click="toAlarm('onWarning')"
                            style="cursor: pointer"
                            >{{ healthStatInfo.warningCount }}
                          </strong>
                          <h4 class="HealthTitle">
                            {{ $t("desc.WarningNumber") }}
                          </h4>
                        </div>
                      </el-col>
                      <el-col :xs="12" :sm="12" :md="6" :lg="12">
                        <div class="HealthRateUl" style="border-color: #cf554a">
                          <strong
                            class="HealthNum"
                            @click="toAlarm('onTrip')"
                            style="cursor: pointer"
                            >{{ healthStatInfo.tripCount }}
                          </strong>
                          <h4 class="HealthTitle">
                            {{ $t("desc.TripNumber") }}
                          </h4>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="8">
                  <div class="homeCon">
                    <h4 class="BoxTitle" style="text-align: left">
                      {{ $t("desc.RecentDaysAirCompressorRegistrationTrend") }}
                    </h4>
                    <h5 class="subTitle">{{ $t("desc.curMonthReal") }}</h5>
                    <div
                      class="homeEchart npPointer"
                      id="registpie"
                      style="height: 220px; margin-bottom: 40px"
                    ></div>
                    <h5 class="subTitle center">
                      <strong
                        v-bind:class="
                          registerStatInfo.registerRateTB > 0
                            ? 'green'
                            : registerStatInfo.registerRateTB < 0
                            ? 'red'
                            : ''
                        "
                        >{{ registerStatInfo.registerRateTB }}%
                        <i
                          v-if="registerStatInfo.registerRateTB > 0"
                          class="el-icon-top"
                        ></i>
                        <i
                          v-if="registerStatInfo.registerRateTB == 0"
                          class="el-icon-minus"
                        ></i>
                        <i
                          v-if="registerStatInfo.registerRateTB < 0"
                          class="el-icon-bottom"
                        ></i>
                      </strong>
                    </h5>
                    <div
                      class="homeEchart npPointer"
                      id="homeLine"
                      style="height: 151px"
                    ></div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="8">
                  <div class="homeCon" @click="toUseRate()" style="cursor: pointer">
                    <h4 class="BoxTitle" style="text-align: left">
                      {{ $t("desc.Industryutilizationrate") }}
                    </h4>
                    <h5 class="subTitle">{{ $t("desc.lastmonth") }}</h5>
                    <div class="IndustryNum">
                      <strong class="Num">{{ point }}%</strong>
                      <h5 class="subTitle">
                        <strong
                          v-bind:class="pointTB > 0 ? 'green' : pointTB < 0 ? 'red' : ''"
                          >{{ pointTB }}%
                          <i v-if="pointTB > 0" class="el-icon-top"></i>
                          <i v-if="pointTB == 0" class="el-icon-minus"></i>
                          <i v-if="pointTB < 0" class="el-icon-bottom"></i>
                        </strong>
                      </h5>
                    </div>
                    <div
                      class="homeEchart"
                      id="IndustryPie"
                      style="height: 130px; margin-top: 15px; margin-bottom: 9px"
                    ></div>
                    <el-row :gutter="24" style="margin-top: 6px; height: 257px">
                      <template v-for="item in industryRateTopData">
                        <el-col
                          :xs="12"
                          :sm="12"
                          :md="12"
                          :lg="12"
                          :key="item.industryName"
                        >
                          <div class="IndustryUl">
                            <h4 class="Title">
                              {{ item.industryName }}
                            </h4>
                            <strong class="Num"
                              >{{ item.rate }}%
                              <h5 class="subTitle">
                                <strong
                                  v-bind:class="
                                    item.rateTB > 0
                                      ? 'green'
                                      : item.rateTB < 0
                                      ? 'red'
                                      : ''
                                  "
                                  >{{ item.rateTB }}%
                                  <i v-if="item.rateTB > 0" class="el-icon-top"></i>
                                  <i v-if="item.rateTB == 0" class="el-icon-minus"></i>
                                  <i v-if="item.rateTB < 0" class="el-icon-bottom"></i>
                                </strong>
                              </h5>
                            </strong>
                          </div>
                        </el-col>
                      </template>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :xs="24" :sm="4" :md="3" :lg="3">
              <div class="rightsideDiv" :style="rightH">
                <div class="homeConNoBG">
                  <h4 class="BoxTitle" style="text-align: left; max-width: 157px">
                    {{ $t("desc.IoTInsight") }}
                  </h4>
                  <h5 class="subTitle">{{ $t("desc.weekLy") }}</h5>

                  <el-carousel
                    height="575px"
                    :autoplay="false"
                    :interval="8000"
                    arrow="nerver"
                    indicator-position="outside"
                  >
                    <el-carousel-item
                      v-for="k in Math.ceil(insightStatList.length / 4)"
                      :key="k"
                    >
                      <ul class="IotInsight">
                        <li
                          v-for="item in insightStatList.slice((k - 1) * 4, k * 4)"
                          :key="item.insightName"
                        >
                          <img src="~assets/img/icon_Oil_Separat_or_Element.png" />
                          <span
                            class="title"
                            :title="
                              activeLang == 'zh' ? item.insightName : item.insightEn
                            "
                            >{{
                              activeLang == "zh" ? item.insightName : item.insightEn
                            }}</span
                          >
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="text-decoration: none; color: white; cursor: pointer"
                              href="javascript:;"
                              v-on:click="getInsightUrl(item)"
                              >{{ item.count }}</a
                            >
                          </h4>
                        </li>
                      </ul>
                    </el-carousel-item>
                  </el-carousel>

                      <ul class="IotInsight">
                        <li>
                          <img src="~assets/img/icon_Oil_Separat_or_Element.png" />
                          <span class="title">Oil Separator Element</span>
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="
                                text-decoration: none;
                                color: white;
                                cursor: pointer;
                              "
                              href="javascript:;"
                              @click="getInsight3Url()"
                              >{{ insight3_count }}</a
                            >
                          </h4>
                        </li>
                        <li>
                          <img src="~assets/img/icon_Oil_Filter.png" />
                          <span class="title">Oil Filter</span>
                          <h4 class="num">
                            <span
                              style="color: white; cursor: pointer"
                              @click="getInsight4Url()"
                              >{{ insight4_count }}</span
                            >
                          </h4>
                        </li>
                        <li>
                          <img src="~assets/img/icon_Inlet_Filter.png" />
                          <span class="title">Inlet Filter</span>
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="
                                text-decoration: none;
                                color: white;
                                cursor: pointer;
                              "
                              href="javascript:;"
                              @click="getInsight5Url()"
                              >{{ insight5_count }}</a
                            >
                          </h4>
                        </li>
                        <li>
                          <img src="~assets/img/icon_Inlet_Filter.png" />
                          <span class="title">Consumable Parts</span>
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="
                                text-decoration: none;
                                color: white;
                                cursor: pointer;
                              "
                              href="javascript:;"
                              @click="getInsight1Url()"
                              >{{ insight1_count }}</a
                            >
                          </h4>
                        </li>
                        <li>
                          <img src="~assets/img/icon_Inlet_Filter.png" />
                          <span class="title">Hard Parts</span>
                          <h4 class="num">
                            <a
                              target="_blank"
                              style="
                                text-decoration: none;
                                color: white;
                                cursor: pointer;
                              "
                              href="javascript:;"
                              @click="getInsight2Url()"
                              >{{ insight2_count }}</a
                            >
                          </h4>
                        </li>
                      </ul> 
                </div>
              </div>
            </el-col> -->
            <el-col :xs="24" :sm="24" :lg="24" style="position: relative">
              <div class="RecordBox">
                <el-link href="http://www.irconnectivity.com" target="_blank"
                  >备案主体：英格索兰（中国）投资有限公司
                </el-link>
                <el-link href="http://www.beian.miit.gov.cn" target="_blank"
                  >备案号：沪ICP备05062828号-5
                </el-link>
                <el-link
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
                  target="_blank"
                  ><img
                    src="~assets/img/recordicon.png"
                    style="float: left; width: 16px"
                  />沪公网安备 31010502005741号
                </el-link>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  GetCityStatByBigRegion,
  GetBigRegionStat,
  GetIndustryRateSum,
  GetIndustryRateTop,
  GetHomeStat,
  GetHomeDeviceStat,
  GetHomeHealthStat,
  GetHomeRegisterStat,
  GetAlarmTrendData,
  GetBill,
  GetCurrenSixMonthBill,
  CalcWaitServiceHistoryData,
  CalcExpireServiceData,
  GetUseAmout,
  GetSimStatusNumber,
  getInsightToken,
  GetHealthRateTrend,
  getInsightStatList,
} from "../../api/api";

export default {
  name: "index",
  data() {
    return {
      rightH: {
        height: "",
      },
      jumpUrl: "",
      insight1_url: "",
      insight2_url: "",
      insight3_url: "",
      insight4_url: "",
      insight5_url: "",
      insight1_count: "",
      insight2_count: "",
      insight3_count: "",
      insight4_count: "",
      insight5_count: "",
      insightStatList: [],
      IndustryData: [
        {
          name: "Computer and Electronic Product",
          num: 85.21,
        },
        {
          name: "Chemical Manufacturing",
          num: 74.78,
        },
        {
          name: "Transportation Equipment",
          num: 68.36,
        },
        {
          name: "Machinery Manufacturing",
          num: 65.25,
        },
        {
          name: "Electrical Equipment and Applicaiton",
          num: 52.2,
        },
      ],
      ChinaMapData: [],
      point: 0,
      pointTB: 0,
      barData: [
        this.$t("desc.oilandgasexploitation"),
        this.$t("desc.miningindustry"),
        this.$t("desc.MiningAuxiliaryActivity"),
        this.$t("desc.publicutilities"),
        this.$t("desc.food"),
      ],
      seriesData: [99.78, 99.73, 97.62, 95.17, 94.38],
      bigRegionData: [],
      customerRegion: "",
      type: "0",
      pRChart: "",
      areaList: [],
      dataLine: [],
      timeLine: [],
      tripdataLine: [],
      triptimeLine: [],
      warningdataLine: [],
      warningtimeLine: [],
      healthdataLine: [],
      healthtimeLine: [],
      regionName: "China",
      map: new Map(),
      mapHead: new Map(),
      deviceStatInfo: {},
      healthStatInfo: {},
      registerStatInfo: {},
      headerInfo: {
        bindCount: 0,
        onLineCount: 0,
        sendOutCount: 0,
        sumCount: 0,
        tripCount: 0,
        unConnectCount: 0,
        warningCount: 0,
        waitServiceCount: 0,
        expireServiceCount: 0,
        warningAndTripCount: 0,
      },
      waitServiceDataLine: [],
      waitServiceTimeLine: [],
      expireServiceDataLine: [],
      expireServiceTimeLine: [],
      industryRateTopData: [],

      WarningData: [],
      TripData: [],
      UpName: "",
      upbtn: true,
      Data: [
        {
          name: "world",
          datalist: [
            {
              name: "China",
              value: 0,
            },
          ],
        },
      ],
      paramsList: {
        names: [
          //把各个大区的省份用二维数组分开
          [],
          [],
        ],
        properties: {
          //自定义大区的名字，要和上面的大区省份一一对应
          name: ["华北", "东北", "华东", "华南", "中西"],
          cp: [
            //经纬度可以自己随意定义
            [116.24, 39.54],
            [126.32, 43.5],
            [121.28, 31.13],
            [113.15, 23.08],
            [104.04, 30.39],
          ],
        },
      },
      triggerOn: "mousemove",
      cityMap: new Map(),
      mapList: "",
      nowBigFont: "",
      nowSMFont: "",
      nowXSfONT: "",
      lastInvoiceAmount: "",
      averageAmount: "",
      billInfos: [],
      yearMonthList: [],
      //本月流量使用量
      useAmount: "",
      simNums: {
        testNum: 0,
        readyNum: 0,
        inactNum: 0,
        actNum: 0,
        suspendNum: 0,
        preTerNum: 0,
        simTotal: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      //ChinaJsonStore: "ChinaJson",
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },

  created() {
    var that = this;
    that.getInsightList();

    window.addEventListener("resize", this.SetMapHeight);

    var that = this;
    that.ChinaMapData = []; //JSON.parse(JSON.stringify(ChinaArea));

    this.$nextTick(() => {
      this.SetMapHeight();
      var _self = this;
      setTimeout(function () {
        //_self.getHomeStat();
        _self.getHomeDeviceStat();
        _self.getHomeHealthStat();
        _self.getHomeRegisterStat();
        _self.initHealthLineECharts();
        _self.IndustryRateSum().then((res) => {
          _self.initIndustryPie();
        });
        _self.IndustryRateTop();
      });
    });
  },
  methods: {
    async IndustryRateSum() {
      var that = this;
      await GetIndustryRateSum().then((res) => {
        if (res.success && res.result) {
          that.point = res.result.rate;
          that.pointTB = res.result.rateTB;
        }
      });
    },
    IndustryRateTop() {
      var that = this;
      GetIndustryRateTop().then((res) => {
        if (res.success && res.result) {
          var data = JSON.parse(JSON.stringify(res.result)),
            arr1 = [],
            arr2 = [];
          var industryNameTemp = "";
          data.map((item) => {
            if (that.$store.state.language == "zh")
              //arr1.push(item.industryName);
              industryNameTemp = item.industryName;
            else {
              if (item.industryNameEn != null && item.industryNameEn != "")
                //arr1.push(item.industryNameEn);
                industryNameTemp = item.industryNameEn;
              //arr1.push(item.industryName);
              else industryNameTemp = item.industryName;
            }
            //arr2.push(item.rate);

            that.industryRateTopData.push({
              industryName: industryNameTemp,
              rate: item.rate,
              rateTB: item.rateTB,
            });
          });

          that.barData = arr1;
          that.seriesData = arr2;
        }
      });
    },
    getHomeStat() {
      var data = "";
      var that = this;
      GetHomeStat().then((res) => {
        if (res.success) {
          data = JSON.parse(JSON.stringify(res.result));
          that.Data[0].datalist[0].value = res.result[0].sumCount;
          this.headerInfo.sumCount = res.result[0].sumCount;
          data.map((i) => {
            this.mapHead.set(i.regionName, i);
          });

          var data1 = "";
          if (this.regionName == "China") {
            data1 = "中国";
          } else {
            data1 = this.regionName;
          }
          this.headerInfo = {
            ...this.headerInfo,
            ...this.mapHead.get(data1),
          };
          data.map((item) => {
            var arr1 = [],
              arr2 = [];
            item.bindDataList.map((i) => {
              arr1.push(i.bindCount);
              //arr2.push(i.date.substring(0, 5));
              arr2.push(i.date);
            });

            this.map.set(item.regionName, {
              dataLine: arr1,
              timeLine: arr2,
            });
          });
          that.initLineECharts("");
          that.initPieRegist();
        }
      });
      return data;
    },

    getHomeDeviceStat() {
      var that = this;
      GetHomeDeviceStat().then((res) => {
        if (res.success) {
          that.deviceStatInfo = res.result;
          that.initPieRegist();
        }
      });
    },
    getHomeHealthStat() {
      var that = this;
      GetHomeHealthStat().then((res) => {
        if (res.success) {
          that.healthStatInfo = res.result;
        }
      });
    },
    getHomeRegisterStat() {
      var that = this;
      GetHomeRegisterStat().then((res) => {
        if (res.success) {
          that.registerStatInfo = res.result;
          that.initLineECharts("");
        }
      });
    },
    async getHealthRateTrend() {
      var that = this;
      that.healthdataLine = [];
      that.healthtimeLine = [];
      await GetHealthRateTrend().then((res) => {
        if (res.success) {
          var data = JSON.parse(JSON.stringify(res.result));
          data.map((o) => {
            that.healthdataLine.push(o.rate);
            that.healthtimeLine.push(o.date);
          });
        }
      });
    },

    async getAlarmTrendData(type, regionName) {
      var that = this;
      // that.tripdataLine = [];
      // that.triptimeLine = [];
      await GetAlarmTrendData(type, regionName).then((res) => {
        if (res.success) {
          var data = JSON.parse(JSON.stringify(res.result));
          if (type == 1) {
            data.map((o) => {
              that.tripdataLine.push(o.count);
              that.triptimeLine.push(o.date);
            });
          } else {
            data.map((o) => {
              that.warningdataLine.push(o.count);
              that.warningtimeLine.push(o.date);
            });
          }
        }
      });
    },
    async getWaitServiceTrendData(regionName) {
      var that = this;
      that.waitServiceDataLine = [];
      that.waitServiceTimeLine = [];
      await CalcWaitServiceHistoryData(regionName).then((res) => {
        if (res.success) {
          var data = JSON.parse(JSON.stringify(res.result));
          data.map((o) => {
            that.waitServiceDataLine.push(o.count);
            that.waitServiceTimeLine.push(o.date);
          });
        }
      });
    },
    async getExpireServiceTrendData(regionName) {
      var that = this;
      that.expireServiceDataLine = [];
      that.expireServiceTimeLine = [];
      await CalcExpireServiceData(regionName).then((res) => {
        if (res.success) {
          var data = JSON.parse(JSON.stringify(res.result));
          data.map((o) => {
            that.expireServiceDataLine.push(o.count);
            that.expireServiceTimeLine.push(o.date);
          });
        }
      });
    },
    toAlarm(e) {
      this.$router.push({
        name: "/Alarm/AlarmList",
        params: {
          customerRegion: this.customerRegion,
          alarmStatus: "1",
          alarmType: e || "",
          isContainWJ: "false",
        },
      });
    },
    toMaintain(state) {
      this.$router.push({
        name: "/maintain/index",
        params: {
          maintainType: state,
        },
      });
    },
    toTripRate() {
      this.$router.push({
        name: "/report/deviceStatistics",
      });
    },
    toAirCWithtime(val) {
      this.$router.push({
        name: "/device/register",
        params: {
          times: val,
        },
      });
    },
    toMonitorWithCust(val) {
      this.$router.push({
        name: "/monitor/list",
        params: {
          customerId: val,
        },
      });
    },
    toUseRate() {
      this.$router.push({
        name: "/report/UtilizationStat2",
      });
    },
    toInstallKPI() {
      this.$router.push({
        name: "/report/installKPI",
      });
    },
    //跳转空压机注册
    toDeviceRegi(gatewayState, gsnState, isContainWJ = "false") {
      this.$router.push({
        name: "/device/register",
        params: {
          gatewayState: gatewayState,
          gsnState: gsnState,
          isContainWJ: isContainWJ,
        },
      });
    },
    //获取头部数据
    async getStatInfo(e, w) {
      e = encodeURI(e);
      var result = {},
        resultData = "";
      if (e.length > 0) {
        var that = this;
        if (w != "mousemove") {
          //查询全国 大区下 空压机总台数
          if (that.type == "1") {
            //获取大区 下空压机总台数
            await GetBigRegionStat()
              .then((res) => {
                if (res.success) {
                  result = JSON.parse(JSON.stringify(res.result));
                  resultData = JSON.parse(JSON.stringify(res.result));
                }
              })
              .catch((err) => {
                // that.$message.error(err.error.message);
              });
          } else if (that.type == "2") {
            //获取城市下 空压机总台数
            await GetCityStatByBigRegion(e).then((res) => {
              if (res.success) {
                that.bigRegionData = JSON.parse(JSON.stringify(res.result));
                result = JSON.parse(JSON.stringify(res.result));
                resultData = JSON.parse(JSON.stringify(res.result));
              }
            });
          }
          resultData.map((i) => {
            this.mapHead.set(i.regionName, i);
          });
          var data1 = this.regionName;
          this.headerInfo = {
            ...this.headerInfo,
            ...this.mapHead.get(data1),
          };
          resultData.map((item) => {
            var arr1 = [],
              arr2 = [];
            item.bindDataList.map((i) => {
              arr1.push(i.bindCount);
              //arr2.push(i.date.substring(0, 5));
              arr2.push(i.date);
            });
            this.map.set(item.regionName, {
              dataLine: arr1,
              timeLine: arr2,
            });
          });
          //that.initHealthBarECharts();
          that.initLineECharts("");
          that.initPieRegist();
          that.initLineS1();

          that.initLineTrip();
          that.initLineWarning();
        }
        return result;
      }
    },
    SetMapHeight() {
      //var mHeight = document.documentElement.clientHeight - 150; //总高
      var mWidth = document.documentElement.clientWidth;
      //var topHeight = this.$refs.mapnum.clientHeight;
      if(this.$refs.leftCon){
        var leftCon = this.$refs.leftCon.$el.clientHeight;
        if (mWidth < 767) {
          this.rightH.height = "auto";
        } else {
          this.rightH.height = leftCon - 30 + "px";
        }
      }
    },

    createHtml(item, a) {
      var that = this;
      let txtCon =
        "<div class='mapTooltip'>" +
        "<h4>" +
        item.data.name +
        "<br />" +
        a +
        " : " +
        '<a style="color: #c1ffff;" href="javascript:void(0);" style="cursor:pointer;" onclick="toMonitorWithCust(\'' +
        item.data.id +
        "')\">" +
        item.data.value[2] +
        "</a>" +
        "</h4>" +
        "</div>";
      window.toMonitorWithCust = function (val) {
        that.toMonitorWithCust(val);
      };
      return txtCon;
    },
    GetData(mapname, List) {
      var temp = [];
      List.forEach(function (t) {
        if (t.name == mapname) temp.push(t.datalist);
      });
      return temp[0];
    },
    setChildData(list) {
      this.Data.map((i) => {
        i.datalist.map((j) => {
          list.map((k) => {
            if (j.name == k.regionName) {
              j.clientList = k.customerData;
            }
          });
        });
      });
    },
    getChildData(e, w) {
      var data = "";
      this.Data.map((i) => {
        if (i.name == e) {
          i.datalist.map((j) => {
            if (j.name == w) {
              data = j.clientList;
            }
          });
        }
      });
      return data;
    },
    getChildName(mapname) {
      var temp = [];
      this.Data.forEach(function (t) {
        if (t.name == mapname) {
          t.datalist.map((j) => {
            temp.push(j.name);
          });
        }
      });
      return temp;
    },
    getNewData(mapname, newList) {
      this.Data.map((i) => {
        if (i.name == mapname) {
          i.datalist.map((j) => {
            if (newList.length > 0) {
              newList.map((k) => {
                if (j.name == k.regionName) {
                  j.value = k.sumCount;
                }
              });
            }
          });
        }
      });
      // return List;
    },

    getP(i) {
      var temp = {};
      temp = {
        names: this.paramsList.names[i],
        properties: {
          name: this.paramsList.properties["name"][i],
          cp: this.paramsList.properties["cp"][i],
        },
      };

      return temp;
    },

    // 健康度饼图
    initHealthBarECharts() {
      var HealthBar = this.$echarts.init(document.getElementById("HealthBar"));
      const handred = this.headerInfo.bindCount; //总台数
      let pointTrip = this.headerInfo.warningAndTripCount; //tripCount; //故障台数
      let pointWarning = 0; //this.headerInfo.warningCount; //警告台数
      //let pointUnconnect = this.headerInfo.unConnectCount; //未连接台数
      // const handred = 100; //总台数
      // let pointTrip = 60; //故障台数
      // let pointWarning = 2; //警告台数
      // let pointUnconnect = 4; //未连接台数

      let dataHealth = [];
      let dataAll = [];
      dataHealth.push(handred - (pointTrip + pointWarning));
      //dataAll.push(pointTrip + pointWarning + pointUnconnect);
      dataAll.push(handred);

      var optionHealthBar = {
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        xAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            //名称
            type: "category",
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],

        series: [
          {
            name: "health",
            type: "bar",
            stack: "all",
            barWidth: 10,
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "#28739A",
                barBorderRadius: [30, 0, 0, 30],
              },
            },
            data: dataHealth,
          },
          {
            name: "",
            type: "bar",
            stack: "all",
            barWidth: 10,
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "#3A3C46",
                barBorderRadius: [0, 30, 30, 0],
              },
            },
            data: dataAll,
          },
        ],
      };
      HealthBar.setOption(optionHealthBar);

      window.addEventListener("resize", () => {
        HealthBar.resize();
      });
    },
    // 健康度 只显示健康度按月曲线近6个月
    async initHealthLineECharts() {
      var self = this;
      await self.getHealthRateTrend();
      var HealthLine = this.$echarts.init(document.getElementById("HealthLine"));
      // let ServiceData = self.waitServiceDataLine;
      // let OverdueData = self.expireServiceDataLine;

      let HealthData = self.healthdataLine;
      let timeLineData = self.healthtimeLine;

      // let HealthData =  [125, 125, 122, 149, 185, 159]; //健康度曲线
      // let timeLineData = [
      //   "202106",
      //   "202107",
      //   "2021068",
      //   "202109",
      //   "202110",
      //   "202111",
      // ];

      var optionHealthLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: "top",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 20,
          left: 40,
          right: 10,
          bottom: 40,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          boundaryGap: false,
          data: timeLineData,
        },
        yAxis: {
          max: 100,
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            name: this.$t("title.faultRate"),
            type: "line",
            smooth: true, //是否平滑
            showSymbol: false,
            symbolSize: 2,
            lineStyle: {
              normal: {
                color: "#28739A",
              },
            },
            itemStyle: {
              color: "#28739A",
              borderColor: "#28739A",
              borderWidth: 2,
            },
            emphasis: {
              focus: "series",
            },
            data: HealthData,
          },
        ],
      };
      HealthLine.setOption(optionHealthLine);

      window.addEventListener("resize", () => {
        HealthLine.resize();
      });
    },

    //空压机折线图
    initLineECharts(e) {
      if (!e) {
        e = this.regionName;
      }
      var homeLine = this.$echarts.init(document.getElementById("homeLine"));
      var that = this;
      // homeLine.on("click", function (params) {
      //   that.toAirCWithtime(params.name);
      // });

      // var dataLine = this.map.get(e == "China" ? "中国" : e).dataLine || [];
      // var timeLine = this.map.get(e == "China" ? "中国" : e).timeLine || [];

      var dataLine = [];
      var timeLine = [];

      that.registerStatInfo.bindDataList.map((i) => {
        dataLine.push(i.bindCount);
        timeLine.push(i.date);
      });

      var optionLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 50, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: "{b}<br />{a}:<br />{c}",
        },
        grid: {
          top: 5,
          left: 40,
          right: 5,
          bottom: 20,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },

          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            name: this.$t("desc.registrationNumber"),
            type: "line",
            cursor: "default",
            smooth: true, //是否平滑
            showAllSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              normal: {
                color: "rgba(255,255,255,1)",
              },
            },
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            emphasis: {
              cursor: "default",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(255,255,255,0.5)" },
                  { offset: 0.9, color: "rgba(255,255,255,0)" },
                  { offset: 1, color: "rgba(255,255,255,0)" },
                ]),
              },
            },
            data: dataLine,
          },
        ],
      };

      homeLine.setOption(optionLine);

      window.addEventListener("resize", () => {
        homeLine.resize();
      });
    },
    //空压机注册饼图
    initPieRegist() {
      var registpie = this.$echarts.init(document.getElementById("registpie"));
      // const handred = this.headerInfo.sendOutCount; //总空压机数
      // let point = this.headerInfo.bindCount; //总注册台数
      const handred = this.deviceStatInfo.sendOutCount; //总空压机数
      let point = this.deviceStatInfo.bindCount; //总注册台数
      // const handred = 195; //总空压机数
      // let point = 142; //总注册台数
      var optionRegistpie = {
        tooltip: {
          show: false,
        },
        series: [
          {
            name: "circle",
            type: "pie",
            clockWise: true,
            center: ["50%", "50%"],
            radius: ["73%", "90%"],
            hoverAnimation: false,
            cursor: "default",
            data: [
              {
                value: ((point / handred) * 100).toFixed(1),
                name: this.$t("title.proportion"),
                label: {
                  position: "center",
                  formatter: "{c}%",
                  color: "#fff",
                  fontSize: 32,
                  fontWeight: "bold",
                  fontFamily: "Arial",
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  normal: {
                    color: "#28739A",
                    borderRadius: 20,
                  },
                },
                tooltip: {
                  show: false,
                },
                emphasis: {
                  cursor: "default",
                },
              },
              {
                name: this.$t("title.unutilized"),
                value: (((handred - point) / handred) * 100).toFixed(1),
                itemStyle: {
                  normal: {
                    color: "rgba(0,0,0,0)",
                  },
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                  length: 0,
                  length2: 0,
                },
                tooltip: {
                  show: false,
                },
                emphasis: {
                  cursor: "default",
                },
              },
            ],
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["73%", "90%"],
            hoverAnimation: false,
            data: [100],
            cursor: "default",
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "#3A3C46",
              },
            },
            tooltip: {
              show: false,
            },
            emphasis: {
              cursor: "default",
            },
            z: -1,
          },
        ],
      };
      registpie.setOption(optionRegistpie);

      window.addEventListener("resize", () => {
        registpie.resize();
      });
    },
    //利用率
    initIndustryPie() {
      var IndustryPie = this.$echarts.init(document.getElementById("IndustryPie"));
      const handred = 100;
      let point = this.point;
      var optionIndustryPie = {
        tooltip: {
          show: false,
        },
        series: [
          {
            name: "circle",
            type: "pie",
            clockWise: true,
            center: ["70%", "50%"],
            radius: ["70%", "100%"],
            hoverAnimation: false,
            data: [
              {
                value: point,
                name: this.$t("title.proportion"),
                label: {
                  show: false,
                },
                labelLine: {
                  normal: {
                    show: false,
                  },
                  emphasis: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "#28739A",
                    borderRadius: 20,
                  },
                },
                tooltip: {
                  show: false,
                },
              },
              {
                name: this.$t("title.unutilized"),
                value: handred - point,
                itemStyle: {
                  normal: {
                    color: "rgba(0,0,0,0)",
                  },
                },
                label: {
                  show: false,
                },
                labelLine: {
                  normal: {
                    show: false,
                  },
                  emphasis: {
                    show: false,
                  },
                },
                tooltip: {
                  show: false,
                },
              },
            ],
          },
          {
            type: "pie",
            center: ["70%", "50%"],
            radius: "15%",
            hoverAnimation: false,
            data: [100],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            tooltip: {
              show: false,
            },
            z: -2,
          },
          {
            type: "pie",
            center: ["70%", "50%"],
            radius: ["70%", "100%"],
            hoverAnimation: false,
            data: [100],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "#3A3C46",
              },
            },
            tooltip: {
              show: false,
            },
            z: -1,
          },
        ],
      };
      IndustryPie.setOption(optionIndustryPie);

      window.addEventListener("resize", () => {
        IndustryPie.resize();
      });
    },
    initBarEcharts() {
      var homeBar = this.$echarts.init(document.getElementById("homeBar")),
        that = this;
      var optionBar = {
        tooltip: {
          show: false,
        },

        grid: {
          top: 20,
          left: 20,
          right: 20,
          bottom: 22,
        },
        xAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            //名称
            type: "category",
            offset: -10,
            position: "left",
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: "#999",
              align: "left",
              verticalAlign: "bottom",
              lineHeight: 20,
              fontSize: this.nowXSfONT,
              fontFamily: "Arial",
            },
            width: "100%",
            data: that.barData,
          },
        ],
        series: [
          {
            name: this.$t("desc.useratio"),
            type: "bar",
            stack: this.$t("desc.gross"),
            barWidth: 5,
            label: {
              show: false,
              position: "insideRight",
              fontFamily: "Arial",
            },
            itemStyle: {
              normal: {
                color: "#6390B9",
                //width:"100%",
                barBorderRadius: [30, 0, 0, 30],
              },
            },
            data: that.seriesData,
          },
          {
            name: "",
            type: "bar",
            stack: this.$t("desc.gross"),
            barWidth: 5,
            label: {
              show: true,
              position: "insideRight",
              offset: [0, -10],
              color: "#000",
              //  fontFamily:"Arial, 'youyuan'",
              fontSize: this.nowXSfONT,
              fontWeight: "normal",
              formatter: (params) => {
                var text;
                text = parseFloat(100 - params.data).toFixed(2) + "%";
                return text;
              },
              fontFamily: "Arial",
            },
            itemStyle: {
              normal: {
                color: "#CED6D6",
                //width:"100%",
                fontSize: this.nowXSfONT,
                barBorderRadius: [0, 30, 30, 0],
              },
            },
            // data: [0.22, 0.27, 2.38, 4.83, 5.62],
            data: that.seriesData.map((item) => {
              return parseFloat(100 - item).toFixed(2);
            }),
          },
        ],
      };

      homeBar.setOption(optionBar);

      window.addEventListener("resize", () => {
        homeBar.resize();
      });
    },

    initLineTrip() {
      var homeLineTrip = this.$echarts.init(document.getElementById("homeLineTrip"));

      var dataLine = this.tripdataLine;
      var timeLine = this.triptimeLine;

      var optionLineTrip = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#B5B5B5",
            },
          },
        },
        grid: {
          top: 30,
          left: 0,
          right: 0,
          bottom: 22,
        },
        xAxis: {
          data: timeLine,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: {
          name: this.$t("desc.TripNumber"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: true,
          symbol: "circle",
          symbolSize: 0,
          lineStyle: {
            normal: {
              color: "rgba(225, 82, 61,1)",
            },
          },
          itemStyle: {
            color: "rgba(225, 82, 61,1)",
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(225, 82, 61,0.5)" },
                { offset: 1, color: "rgba(225, 82, 61,0.05)" },
              ]),
            },
          },
          data: dataLine,
        },
      };
      homeLineTrip.setOption(optionLineTrip);

      window.addEventListener("resize", () => {
        homeLineTrip.resize();
      });
    },
    initLineWarning() {
      var homeLineWarning = this.$echarts.init(
        document.getElementById("homeLineWarning")
      );

      var dataLine = this.warningdataLine;
      var timeLine = this.warningtimeLine;

      var optionLineWarning = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#B5B5B5",
            },
          },
        },
        grid: {
          top: 30,
          left: 0,
          right: 0,
          bottom: 22,
        },
        xAxis: {
          data: timeLine,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: {
          name: this.$t("desc.WarningNumber"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: true,
          symbol: "circle",
          symbolSize: 0,
          lineStyle: {
            normal: {
              color: "rgba(238, 202, 63,1)",
            },
          },
          itemStyle: {
            color: "rgba(238, 202, 63,1)",
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(238, 202, 63,0.5)" },
                { offset: 1, color: "rgba(238, 202, 63,0.05)" },
              ]),
            },
          },
          data: dataLine,
        },
      };
      homeLineWarning.setOption(optionLineWarning);

      window.addEventListener("resize", () => {
        homeLineWarning.resize();
      });
    },
    initLineS1() {
      var homeLineS1 = this.$echarts.init(document.getElementById("homeLineS1"));

      var dataLine = this.waitServiceDataLine;
      var timeLine = this.waitServiceTimeLine;

      var optionLineS1 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#B5B5B5",
            },
          },
        },
        grid: {
          top: 30,
          left: 0,
          right: 0,
          bottom: 22,
        },
        xAxis: {
          data: timeLine,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: {
          name: this.$t("desc.NumberforService"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: true,
          symbol: "circle",
          symbolSize: 0,
          lineStyle: {
            normal: {
              color: "rgba(62,170,53,1)",
            },
          },
          itemStyle: {
            color: "rgba(62,170,53,1)",
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(62,170,53,0.5)" },
                { offset: 1, color: "rgba(62,170,53,0.05)" },
              ]),
            },
          },
          data: dataLine,
        },
      };
      homeLineS1.setOption(optionLineS1);

      window.addEventListener("resize", () => {
        homeLineS1.resize();
      });
    },
    initLineS2() {
      var homeLineS2 = this.$echarts.init(document.getElementById("homeLineS2"));

      var dataLine = this.expireServiceDataLine;
      var timeLine = this.expireServiceTimeLine;

      var optionLineS2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#B5B5B5",
            },
          },
        },
        grid: {
          top: 30,
          left: 0,
          right: 0,
          bottom: 22,
        },
        xAxis: {
          data: timeLine,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: {
          name: this.$t("desc.NumberofServiceOverdue"),
          type: "line",
          smooth: true, //是否平滑
          showAllSymbol: true,
          symbol: "circle",
          symbolSize: 0,
          lineStyle: {
            normal: {
              color: "rgba(111,167,173,1)",
            },
          },
          itemStyle: {
            color: "rgba(111,167,173,1)",
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(111,167,173,0.5)" },
                { offset: 1, color: "rgba(111,167,173,0.05)" },
              ]),
            },
          },
          data: dataLine,
        },
      };
      homeLineS2.setOption(optionLineS2);

      window.addEventListener("resize", () => {
        homeLineS2.resize();
      });
    },

    //上月费用
    GetLastInvoiceAmount() {
      var date = new Date();
      var currym = "";
      var monthstr = "";
      if (date.getMonth() == 0) {
        currym = `${date.getFullYear() - 1}${0}${12}`;
      } else if (date.getMonth() > 0 && date.getMonth() < 10) {
        monthstr = `${0}${date.getMonth()}`;
        currym = `${date.getFullYear()}${monthstr}`;
      } else {
        currym = `${date.getFullYear()}${date.getMonth()}`;
      }
      let queryDate = currym;
      GetBill(queryDate).then((res) => {
        if (res.success) {
          this.lastInvoiceAmount = res.result[0].invoiceAmount;
          this.averageAmount = (
            parseFloat(this.lastInvoiceAmount) / parseFloat(this.headerInfo.sumCount)
          ).toFixed(3);
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    GetSixBill() {
      let monthNum = 12;
      GetCurrenSixMonthBill(monthNum).then((res) => {
        if (res.success) {
          this.sixBill = res.result;
          for (let i = 0; i < this.sixBill.length; i++) {
            this.billInfos.push(this.sixBill[i].invoiceAmount);
            this.yearMonthList.push(this.sixBill[i].yearMonth);
          }
          this.$nextTick(() => {
            // this.initLineSIM();
          });
        } else {
          this.$message.error(res.error.message);
        }
      });
    },

    toSimCardInfo() {
      this.$router.push({
        name: "/report/SIMInfo",
      });
    },

    GetCurMonAmout() {
      GetUseAmout().then((res) => {
        if (res.success) {
          this.useAmount = res.result;
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    GetSimStatus() {
      GetSimStatusNumber().then((res) => {
        if (res.success) {
          this.simNums = res.result[0];
          this.simNums.simTotal =
            parseInt(this.simNums.actNum) +
            parseInt(this.simNums.readyNum) +
            parseInt(this.simNums.suspendNum) +
            parseInt(this.simNums.testNum) +
            parseInt(this.simNums.inactNum) +
            parseInt(this.simNums.preTerNum);
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    // async getInsightToken() {
    //   var that = this;
    //   var insightToken = "";
    //   var data = {
    //     username: "sz",
    //     client_ip: "https://irhelix.irconnectivity.com",
    //   };
    //   await getInsightToken(data).then((res) => {
    //     if (res.success) {
    //       insightToken = res.result;
    //     }
    //   });
    //   return insightToken;
    // },
    getInsightList() {
      var that = this;
      getInsightStatList().then((res) => {
        if (res.success) {
          that.insightStatList = res.result;
        }
      });
    },
    async getInsightUrl(insightData) {
      var that = this;
      var newWindow = window.open("", "_blank");
      var insightToken = "";
      var data = {
        username: "sz",
        client_ip: Globals.InsightClient_VerifyUrl,
      };
      await getInsightToken(data).then((res) => {
        if (res.success) {
          insightToken = res.result;
          var insight_url =
            Globals.InsightDomain_Url + insightToken + insightData.insightUrlPath;
          newWindow.location.href = insight_url;
        }
      });
    },
  },
  // watch: {
  //   jumpUrl() {
  //     if (this.jumpUrl) {
  //       window.open(this.jumpUrl, "_blank");
  //     }
  //     this.jumpUrl = null;
  //   },
  // },
};
</script>
